// invoiceLifecycleModel.js
//
// Issue / void lock helpers for INVOICE (independent of documentStatus: sent).

import { readInvoiceField } from 'nodetypes/invoice/view/invoiceGeneralInfoModel';

function normalizeString(value) {
  return String(value || '').trim();
}

/**
 * @param {object|null|undefined} node
 * @param {object|null|undefined} [nodeType]
 * @returns {boolean}
 */
export function isInvoiceVoided(node, nodeType = null) {
  const status = normalizeString(readInvoiceField(node, 'documentStatus', nodeType)).toLowerCase();
  if (status === 'void') return true;
  const voidedAt = readInvoiceField(node, 'voidedAt', nodeType);
  return voidedAt != null && voidedAt !== '';
}

/**
 * @param {object|null|undefined} node
 * @param {object|null|undefined} [nodeType]
 * @returns {boolean}
 */
export function isInvoiceIssued(node, nodeType = null) {
  if (isInvoiceVoided(node, nodeType)) return false;
  const issuedAt = readInvoiceField(node, 'issuedAt', nodeType);
  return issuedAt != null && issuedAt !== '';
}

/**
 * Structure lock: issued invoices cannot edit items / schedule shape.
 * Log Payment remains allowed separately.
 *
 * @param {object|null|undefined} node
 * @param {object|null|undefined} [nodeType]
 * @returns {boolean}
 */
export function isInvoiceStructureLocked(node, nodeType = null) {
  return isInvoiceIssued(node, nodeType) || isInvoiceVoided(node, nodeType);
}

/**
 * @param {object|null|undefined} node
 * @param {object|null|undefined} [nodeType]
 * @returns {boolean}
 */
export function canLogInvoicePayments(node, nodeType = null) {
  return !isInvoiceVoided(node, nodeType);
}
